module.exports = __webpack_public_path__ + "img/home02.0f2746f4.svg";